var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  width: 200,
  height: 200,
  fill: "white"
});
var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_7752_33995)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_f_7752_33995)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 93.9295,
  cy: 148.437,
  rx: 71.701,
  ry: 13.8321,
  fill: "#1F88F8",
  fillOpacity: 0.35
})), /*#__PURE__*/React.createElement("path", {
  d: "M96.5836 165.333C137.649 165.333 170.939 132.043 170.939 90.9781C170.939 49.913 137.649 16.623 96.5836 16.623C55.5184 16.623 22.2285 49.913 22.2285 90.9781C22.2285 132.043 55.5184 165.333 96.5836 165.333Z",
  fill: "url(#paint0_linear_7752_33995)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M154.104 46.6797H59.6602V93.2867H154.104V46.6797Z",
  fill: "url(#paint1_linear_7752_33995)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M154.104 46.6797H163.583C169.763 46.6797 175.689 49.1346 180.059 53.5043C184.429 57.8741 186.884 63.8007 186.884 69.9805C186.884 76.1602 184.429 82.0869 180.059 86.4566C175.689 90.8263 169.763 93.2812 163.583 93.2812H154.104V46.6797Z",
  fill: "url(#paint2_linear_7752_33995)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M160.236 53.5352H165.659C169.83 53.5352 173.83 55.192 176.779 58.1412C179.729 61.0904 181.385 65.0903 181.385 69.2611V70.7047C181.385 74.8755 179.729 78.8755 176.779 81.8247C173.83 84.7738 169.83 86.4307 165.659 86.4307H160.236V53.5352Z",
  fill: "url(#paint3_linear_7752_33995)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M154.104 54.501H67.5918V93.2862H154.104V54.501Z",
  fill: "url(#paint4_linear_7752_33995)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 37.0957,
  y: 101.046,
  width: 35.0751,
  height: 44.9208,
  fill: "url(#paint5_linear_7752_33995)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 80.1719,
  y: 101.046,
  width: 35.0751,
  height: 44.9208,
  fill: "url(#paint6_linear_7752_33995)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 123.246,
  y: 101.046,
  width: 22.7681,
  height: 44.9208,
  fill: "url(#paint7_linear_7752_33995)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M154.104 46.6797H146.041V93.2867H154.104V46.6797Z",
  fill: "url(#paint8_linear_7752_33995)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.1695 93.0459L72.1699 93.0459L72.1699 153.966L80.1695 153.966L80.1695 93.0459Z",
  fill: "url(#paint9_linear_7752_33995)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.842 93.0459H37.4382L37.4381 153.966H33.842C31.2207 153.966 29.0957 151.841 29.0957 149.22L29.0957 97.7922C29.0957 95.1709 31.2207 93.0459 33.842 93.0459ZM118.937 101.045V93.0459H37.4383V101.045H118.937ZM118.937 153.966V145.967H37.4383V153.966H118.937Z",
  fill: "url(#paint10_linear_7752_33995)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M123.244 93.0459H119.99C117.369 93.0459 115.244 95.1709 115.244 97.7922L115.244 153.966H123.244V153.966H146.012L146.012 153.966H149.265C151.886 153.966 154.011 151.841 154.011 149.22L154.011 93.0459H146.012H123.244H123.244ZM146.012 101.045H123.244L123.244 145.967H146.012V101.045Z",
  fill: "url(#paint11_linear_7752_33995)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65.9883 93.3857V93.4736V96.2455V116.44H87.6921C88.2164 116.44 88.6414 116.015 88.6414 115.49V96.2455V94.335C88.6414 93.8107 88.2164 93.3857 87.6921 93.3857H65.9883Z",
  fill: "url(#paint12_linear_7752_33995)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.9903 93.3857C64.466 93.3857 64.041 93.8107 64.041 94.335V115.49C64.041 116.015 64.466 116.44 64.9903 116.44H86.6941V93.3857H64.9903Z",
  fill: "url(#paint13_linear_7752_33995)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.2491 95.5918H68.4923C67.4437 95.5918 66.5938 96.4418 66.5938 97.4903V112.147C66.5938 113.196 67.4437 114.046 68.4923 114.046H82.2491C83.2976 114.046 84.1476 113.196 84.1476 112.147V97.4903C84.1476 96.4418 83.2976 95.5918 82.2491 95.5918Z",
  fill: "url(#paint14_linear_7752_33995)"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d_7752_33995)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.1738 77.7836L32.6927 98.7351C32.8091 99.0223 32.981 99.2837 33.1986 99.5043C33.4162 99.725 33.6752 99.9005 33.9608 100.021C34.2463 100.141 34.5528 100.204 34.8627 100.206C35.1726 100.207 35.4798 100.148 35.7666 100.03L54.8573 92.2745C55.4378 92.0382 55.9008 91.5813 56.1447 91.0039C56.3886 90.4266 56.3935 89.7761 56.1582 89.1952L46.3109 64.9777C46.0748 64.3986 45.6184 63.9369 45.042 63.694C44.4657 63.4512 43.8165 63.4469 43.2371 63.6823L27.3739 70.1319L24.1738 77.7836Z",
  fill: "url(#paint15_linear_7752_33995)"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_d_7752_33995)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M159.096 65.4769L150.577 86.4284C150.46 86.7156 150.289 86.977 150.071 87.1977C149.853 87.4183 149.594 87.5939 149.309 87.7142C149.023 87.8346 148.717 87.8974 148.407 87.899C148.097 87.9007 147.79 87.8411 147.503 87.7238L128.412 79.9679C127.832 79.7316 127.369 79.2746 127.125 78.6973C126.881 78.12 126.876 77.4694 127.111 76.8885L136.959 52.6711C137.195 52.092 137.651 51.6303 138.227 51.3874C138.804 51.1445 139.453 51.1403 140.032 51.3757L155.896 57.8253L159.096 65.4769Z",
  fill: "url(#paint16_linear_7752_33995)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M24.1738 77.7835L29.5915 75.5824L27.3794 70.1318L24.1738 77.7835Z",
  fill: "url(#paint17_linear_7752_33995)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M159.096 65.4769L153.678 63.2758L155.89 57.8252L159.096 65.4769Z",
  fill: "url(#paint18_linear_7752_33995)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.6812 105.593C78.3797 105.102 78.9036 104.401 79.1769 103.592C79.4502 102.783 79.4587 101.908 79.2012 101.094C78.9436 100.28 78.4335 99.5692 77.7447 99.0646C77.0558 98.5601 76.2242 98.2881 75.3704 98.2881C74.5165 98.2881 73.6849 98.5601 72.996 99.0646C72.3072 99.5692 71.7971 100.28 71.5395 101.094C71.282 101.908 71.2905 102.783 71.5638 103.592C71.8371 104.401 72.361 105.102 73.0595 105.593L71.3359 111.527H79.3993L77.6812 105.593Z",
  fill: "url(#paint19_linear_7752_33995)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.347 43.3263C127.347 44.1897 127.217 45.0482 126.962 45.8732C126.55 47.196 125.821 48.3981 124.838 49.3752C124.55 49.6671 124.24 49.9369 123.911 50.1821C123.694 50.3507 123.467 50.5047 123.23 50.6432C122.994 50.7879 122.75 50.9198 122.5 51.0384C122.127 51.2226 121.739 51.3768 121.342 51.4994C120.517 51.7541 119.658 51.8836 118.795 51.8837H117.203V93.1335H72.7422V42.4316C72.7494 40.403 73.5585 38.4596 74.9929 37.0252C76.4273 35.5908 78.3708 34.7817 80.3993 34.7745H118.773C119.842 34.7704 120.902 34.9697 121.896 35.3618C122.172 35.4688 122.441 35.5915 122.703 35.7296C122.835 35.7954 122.961 35.8668 123.087 35.9436C123.191 36.0006 123.292 36.0629 123.389 36.1303C123.908 36.4583 124.388 36.843 124.822 37.2775C125.404 37.8607 125.899 38.5243 126.293 39.248C126.559 39.7358 126.776 40.2488 126.941 40.7794L127.056 41.1911C127.127 41.4661 127.183 41.7446 127.226 42.0254C127.3 42.4553 127.34 42.8902 127.347 43.3263Z",
  fill: "url(#paint20_linear_7752_33995)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.347 43.3259C127.347 44.1893 127.217 45.0478 126.963 45.8728C126.794 46.4021 126.577 46.9147 126.315 47.4042C125.917 48.1269 125.42 48.7902 124.838 49.3747C124.55 49.6667 124.24 49.9364 123.911 50.1816C123.691 50.3463 123.466 50.4945 123.23 50.6427C122.994 50.7874 122.75 50.9193 122.5 51.0379C122.126 51.2198 121.739 51.3739 121.342 51.499C120.517 51.7536 119.658 51.8831 118.795 51.8832H117.203V42.4312C117.207 40.9196 117.656 39.4427 118.494 38.1852C119.333 36.9277 120.524 35.9454 121.918 35.3613C122.193 35.4711 122.467 35.5919 122.725 35.7291C122.857 35.795 122.983 35.8663 123.109 35.9432C123.213 36.0001 123.314 36.0624 123.411 36.1298C123.93 36.4578 124.41 36.8426 124.844 37.277C125.426 37.8602 125.921 38.5238 126.315 39.2475C126.579 39.7364 126.796 40.2492 126.963 40.779L127.078 41.1906C127.149 41.4655 127.206 41.744 127.248 42.025C127.314 42.4554 127.347 42.8903 127.347 43.3259Z",
  fill: "url(#paint21_linear_7752_33995)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M108.325 78.1152H80.2492C79.7794 78.1152 79.3984 78.4949 79.3984 78.9633C79.3984 79.4316 79.7794 79.8113 80.2492 79.8113H108.325C108.795 79.8113 109.176 79.4316 109.176 78.9633C109.176 78.4949 108.795 78.1152 108.325 78.1152Z",
  fill: "#A5C4F1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M108.325 69.415H80.2492C79.7794 69.415 79.3984 69.7947 79.3984 70.2631C79.3984 70.7315 79.7794 71.1111 80.2492 71.1111H108.325C108.795 71.1111 109.176 70.7315 109.176 70.2631C109.176 69.7947 108.795 69.415 108.325 69.415Z",
  fill: "#A5C4F1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M108.324 60.71H90.2434C89.7735 60.71 89.3926 61.0896 89.3926 61.558C89.3926 62.0264 89.7735 62.4061 90.2434 62.4061H108.324C108.794 62.4061 109.175 62.0264 109.175 61.558C109.175 61.0896 108.794 60.71 108.324 60.71Z",
  fill: "#A5C4F1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96.4637 52.0039H80.0516C79.6909 52.0039 79.3984 52.2963 79.3984 52.6571V53.0468C79.3984 53.4076 79.6909 53.7 80.0516 53.7H96.4637C96.8245 53.7 97.1169 53.4076 97.1169 53.0468V52.6571C97.1169 52.2963 96.8245 52.0039 96.4637 52.0039Z",
  fill: "#A5C4F1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M86.2871 60.71H80.2492C79.7794 60.71 79.3984 61.0896 79.3984 61.558C79.3984 62.0264 79.7794 62.4061 80.2492 62.4061H86.2871C86.757 62.4061 87.1379 62.0264 87.1379 61.558C87.1379 61.0896 86.757 60.71 86.2871 60.71Z",
  fill: "#A5C4F1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.4023 101.046H40.1714V145.967H37.4023V101.046Z",
  fill: "url(#paint22_linear_7752_33995)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.1719 116.43H82.6333V145.967H80.1719V116.43Z",
  fill: "url(#paint23_linear_7752_33995)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M123.246 101.046H126.015V145.967H123.246V101.046Z",
  fill: "url(#paint24_linear_7752_33995)"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_f_7752_33995)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 47.886,
  cy: 63.1403,
  rx: 23.7122,
  ry: 7.62176,
  fill: "#FF4C77",
  fillOpacity: 0.3
})), /*#__PURE__*/React.createElement("path", {
  d: "M25.6509 52.0329C26.1082 55.4471 27.4228 58.6898 29.4721 61.4585C31.5215 64.2273 34.2387 66.4319 37.3703 67.8666C40.502 69.3014 43.946 69.9196 47.3811 69.6635C50.8162 69.4074 54.1306 68.2855 57.0149 66.4023L64.8732 69.0738C65.1103 69.1519 65.3647 69.1605 65.6065 69.0986C65.8483 69.0366 66.0673 68.9067 66.2376 68.7243C66.4079 68.5418 66.5224 68.3144 66.5675 68.0689C66.6127 67.8234 66.5866 67.5701 66.4923 67.339L63.3409 59.8218C65.0169 57.0296 65.9998 53.8765 66.2071 50.6265C66.4145 47.3765 65.8403 44.124 64.5326 41.1415C63.225 38.1589 61.2219 35.5329 58.691 33.4834C56.1602 31.4339 53.1752 30.0205 49.986 29.3614C46.7967 28.7023 43.496 28.8167 40.36 29.6952C37.2241 30.5736 34.3442 32.1904 31.9614 34.4103C29.5786 36.6303 27.7622 39.3886 26.6643 42.4546C25.5664 45.5206 25.2189 48.805 25.6509 52.0329Z",
  fill: "url(#paint25_linear_7752_33995)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.3252 59.7612C47.5393 59.7612 49.1164 58.2448 49.1164 56.1217C49.1164 53.9987 47.5393 52.4823 45.3252 52.4823C43.1416 52.4823 41.5341 53.9987 41.5341 56.1217C41.5341 58.2448 43.1416 59.7612 45.3252 59.7612ZM48.3581 51.8757C48.3581 49.874 49.5106 49.1461 51.0877 48.4182C53.1804 47.4477 54.7272 45.4763 54.7272 43.05C54.7272 39.2285 50.9664 36.5596 45.8712 36.5596C40.412 36.5596 36.5602 39.6228 36.2266 43.8992L43.2022 45.173C43.3842 43.5049 44.2637 42.3221 45.5072 42.3221C46.4474 42.3221 47.145 42.959 47.145 43.8385C47.145 44.8697 46.1138 45.5066 45.2949 45.9919C43.1112 47.4173 42.2923 48.9944 42.2923 51.8757H48.3581Z",
  fill: "white"
}));
var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_f_7752_33995",
  x: 0.455521,
  y: 112.831,
  width: 186.948,
  height: 71.2101,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10.8865,
  result: "effect1_foregroundBlur_7752_33995"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d_7752_33995",
  x: 21.3261,
  y: 63.5088,
  width: 51.1432,
  height: 56.6315,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 6.64476,
  dy: 10.4418
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.74626
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.184314 0 0 0 0 0.254902 0 0 0 0 0.443137 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_7752_33995"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_7752_33995",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_d_7752_33995",
  x: 124.09,
  y: 51.2021,
  width: 51.1432,
  height: 56.6315,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 6.64476,
  dy: 10.4418
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.74626
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.184314 0 0 0 0 0.254902 0 0 0 0 0.443137 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_7752_33995"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_7752_33995",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_f_7752_33995",
  x: 2.40083,
  y: 33.7456,
  width: 90.9698,
  height: 58.7892,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10.8865,
  result: "effect1_foregroundBlur_7752_33995"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_7752_33995",
  x1: 96.0104,
  y1: -7.5888,
  x2: 97.5336,
  y2: 253.535,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CAE0FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BCD8FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_7752_33995",
  x1: 106.882,
  y1: 46.6797,
  x2: 106.882,
  y2: 93.2867,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ABCCFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#70A8FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_7752_33995",
  x1: 170.494,
  y1: 46.6797,
  x2: 170.494,
  y2: 93.2812,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#70A8FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5597FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_7752_33995",
  x1: 184.474,
  y1: 87.5075,
  x2: 163.552,
  y2: 59.8166,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EDF4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ABCCFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_7752_33995",
  x1: 110.848,
  y1: 54.501,
  x2: 110.848,
  y2: 93.2862,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2A64BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6095E7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_7752_33995",
  x1: 81.7088,
  y1: 162.581,
  x2: 38.6341,
  y2: 121.968,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EDF4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ABCCFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_7752_33995",
  x1: 117.093,
  y1: 149.966,
  x2: 74.0183,
  y2: 132.121,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EDF4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ABCCFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_7752_33995",
  x1: 155.244,
  y1: 150.89,
  x2: 115.247,
  y2: 113.045,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EDF4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ABCCFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_7752_33995",
  x1: 150.073,
  y1: 46.6797,
  x2: 150.073,
  y2: 93.2867,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ABCCFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#70A8FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_7752_33995",
  x1: 62.3243,
  y1: 111.814,
  x2: 56.7861,
  y2: 165.658,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ABCCFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#70A8FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear_7752_33995",
  x1: 27.5573,
  y1: 103.815,
  x2: 115.553,
  y2: 144.428,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ABCCFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#70A8FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear_7752_33995",
  x1: 184.471,
  y1: 130.89,
  x2: 129.397,
  y2: 132.736,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#70A8FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5597FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint12_linear_7752_33995",
  x1: 77.3148,
  y1: 93.3857,
  x2: 77.3148,
  y2: 116.44,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#70A8FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5597FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint13_linear_7752_33995",
  x1: 75.3676,
  y1: 93.3857,
  x2: 75.3676,
  y2: 116.44,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ABCCFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#70A8FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint14_linear_7752_33995",
  x1: 75.3707,
  y1: 95.5918,
  x2: 75.3707,
  y2: 114.046,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#70A8FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5597FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint15_linear_7752_33995",
  x1: 52.8413,
  y1: 79.8406,
  x2: 31.1896,
  y2: 77.6788,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C6DDFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint16_linear_7752_33995",
  x1: 130.428,
  y1: 67.534,
  x2: 152.08,
  y2: 65.3721,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C6DDFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint17_linear_7752_33995",
  x1: 26.8826,
  y1: 70.1318,
  x2: 26.8826,
  y2: 77.7835,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EDF4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ABCCFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint18_linear_7752_33995",
  x1: 156.387,
  y1: 57.8252,
  x2: 156.387,
  y2: 65.4769,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EDF4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ABCCFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint19_linear_7752_33995",
  x1: 73.4019,
  y1: 107.814,
  x2: 81.4015,
  y2: 108.122,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2A64BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4B80D1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint20_linear_7752_33995",
  x1: 100.044,
  y1: 34.7744,
  x2: 100.044,
  y2: 93.1335,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EDF4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ABCCFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint21_linear_7752_33995",
  x1: 123.554,
  y1: 49.6635,
  x2: 111.555,
  y2: 40.4332,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EDF4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ABCCFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint22_linear_7752_33995",
  x1: 18.0187,
  y1: 143.813,
  x2: 76.2674,
  y2: 137.269,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.09375,
  stopColor: "#2A64BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2A64BE",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint23_linear_7752_33995",
  x1: 62.942,
  y1: 144.55,
  x2: 114.19,
  y2: 136.768,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.09375,
  stopColor: "#2A64BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2A64BE",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint24_linear_7752_33995",
  x1: 103.862,
  y1: 143.813,
  x2: 151.6,
  y2: 148.002,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.09375,
  stopColor: "#265FB8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#84B4FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint25_linear_7752_33995",
  x1: 25.6673,
  y1: 31.6832,
  x2: 66.2971,
  y2: 70.1917,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF698D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF3868"
})));
function SvgNoDataImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7752_33995",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 200,
    height: 200
  }, _ref2), _ref3, _ref4);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataImg);
export default __webpack_public_path__ + "static/media/NoDataImg.845b8362718559c9f758bca2a5bbe231.svg";
export { ForwardRef as ReactComponent };